import React, { useRef } from 'react';
import { ImagePlusIcon, XIcon } from 'lucide-react';
import type { PhotoPreview } from './useLeadForm';
interface PhotoUploadProps {
  photos: PhotoPreview[];
  max: number;
  onAdd: (files: FileList | null) => void;
  onRemove: (id: string) => void;
}
export function PhotoUpload({
  photos,
  max,
  onAdd,
  onRemove
}: PhotoUploadProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const full = photos.length >= max;
  return <div data-id="element-165" data-mp="rkjq66j4ue0r">
      <span className="field-label" data-id="element-166" data-mp="rk9xucam7urw">
        Pool photos <span className="font-normal text-navy/50" data-id="element-167" data-mp="momam2fp1bp1">(optional)</span>
      </span>
      <div className="flex flex-wrap gap-3" data-id="element-168" data-mp="10fhnrqx86eyf">
        {photos.map(p => <div key={p.id} className="relative h-20 w-20 overflow-hidden rounded-xl ring-1 ring-line" data-id="element-169" data-mp="vo9bmn4igfhk">
            <img src={p.url} alt={`Uploaded photo ${p.name}`} className="h-full w-full object-cover" data-id="element-170" data-mp="7yndm2zvk6b5" />
            <button type="button" onClick={() => onRemove(p.id)} aria-label={`Remove ${p.name}`} className="absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-navy-900/80 text-white" data-id="element-171" data-mp="3xbl9ppm96z9">
              <XIcon className="h-3.5 w-3.5" data-id="element-172" data-mp="1zl37b381izhe" />
            </button>
          </div>)}
        {!full && <button type="button" onClick={() => inputRef.current?.click()} className={`flex items-center gap-3 rounded-xl border-2 border-dashed border-navy/20 bg-mist px-4 text-left transition-colors duration-150 hover:border-aqua hover:bg-cyan-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cyan ${photos.length ? 'h-20 w-20 justify-center px-0' : 'h-20 w-full'}`} data-id="element-173" data-mp="29d954tkz4b4i">
            <ImagePlusIcon className="h-6 w-6 shrink-0 text-aqua" aria-hidden="true" data-id="element-174" data-mp="1qo2mt7o3dlj8" />
            {photos.length === 0 && <span data-id="element-175" data-mp="321wlcaqv8ab7">
                <span className="block text-[15px] font-semibold text-navy" data-id="element-176" data-mp="321erfkroe86g">Add photos of your pool</span>
                <span className="block text-sm text-navy/55" data-id="element-177" data-mp="11yvqa67ylsg8">Helps us prepare your estimate. Up to {max}.</span>
              </span>}
            {photos.length > 0 && <span className="sr-only" data-id="element-178" data-mp="1b0d41hxw9i1r">Add more photos</span>}
          </button>}
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple className="sr-only" tabIndex={-1} aria-hidden="true" onChange={e => {
      onAdd(e.target.files);
      e.target.value = '';
    }} data-id="element-179" data-mp="16yrvu9wb1rxw" />
    </div>;
}